import { Component } from '@angular/core';

@Component({
  selector: 'app-home-alerts-section',
  standalone: true,
  templateUrl: './home-alerts-section.component.html'
})
export class HomeAlertsSectionComponent {}
